import { captureRecruitmentContext } from '~/utils/recruitmentContext'

export default async function({ route, store, $axios, error, redirect, app }) {
	const organizationId = route.query?.organization_id
	if (
		typeof organizationId !== 'string' ||
		!/^[1-9]\d*$/.test(organizationId) ||
		!Number.isSafeInteger(Number(organizationId)) ||
		String(store.state.user?.user?.current_organization?.id) ===
			organizationId
	)
		return
	const isCurrent = captureRecruitmentContext(store.state)
	try {
		const user = await $axios.$get(
			`user/change-organization/${organizationId}`,
			{ __skipGlobalErrorToast: true }
		)
		if (!isCurrent()) return
		if (!user) return redirect('/dashboard')
		if (String(user.current_organization?.id) !== organizationId)
			throw new Error(
				'Organization change returned an unexpected workspace'
			)
		const publication = store.dispatch('user/setUser', user)
		const isPublishedContext = captureRecruitmentContext(store.state)
		await publication
		if (!isPublishedContext()) return
		store.commit('organization/setOrganization', user.current_organization)
	} catch (requestError) {
		if (!isCurrent()) return
		const statusCode = requestError?.response?.status || 500
		return error({
			statusCode,
			message: app.i18n.t(
				`error.${
					[403, 404].includes(statusCode) ? statusCode : 500
				}.message`
			)
		})
	}
}
